import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CLINICAL_REVIEW_POA_MANAGE}`,
            render: () => import("../../Pages/Nursing/ExpandedClinicalReviewPlanOfAction/Form/ExpandedClinicalReviewPlanOfActionForm.svelte"),
            title: "Expanded Clinical Review Plan of Action Form"
        }
    ]
};

export default routerConfig;
